class RouteStopHighlight {
  constructor() {
    this.routeStopHighlight = document.querySelector(
      '[data-route-stop-highlight]'
    );
    this.timetableTables = document.querySelectorAll(
      '.timetables__wrapper table'
    );
    this.init();
  }

  init() {
    if (this.routeStopHighlight) {
      const routeStopText =
        this.routeStopHighlight.dataset.routeStopHighlight.trim();

      if (this.timetableTables) {
        this.timetableTables.forEach((table) => {
          const tableHeaders = table.getElementsByTagName('th');

          tableHeaders.forEach((tableHeader, index) => {
            const columnIndex = index;

            if (tableHeader.innerText.trim() === routeStopText) {
              tableHeader.classList.add('selected-data');

              const tableRows = tableHeader
                .closest('table')
                .getElementsByTagName('tr');

              tableRows.forEach((tableRow) => {
                tableRow.cells[columnIndex].classList.add('selected-data');
              });
            }
          });
        });
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new RouteStopHighlight());
